import { BasicRuntimeFormField } from "components/Forms/BasicRuntimeFormField/BasicRuntimeFormField.tsx";
import { FC } from "react";

import FormFieldData = App.Data.FormFieldData;

interface TenantRegistrationFieldsProps {
    fields: FormFieldData[];
}

export const TenantRegistrationFields: FC<TenantRegistrationFieldsProps> = ({ fields }) => {
    return (
        <>
            {fields
                .filter((field) => !field.is_hidden)
                .map((field) => (
                    <BasicRuntimeFormField
                        key={field.id ?? field.system_name}
                        field={field}
                        name={`fields.${field.system_name}`}
                        className="mb-4"
                    />
                ))}
        </>
    );
};
